module.exports = __webpack_public_path__ + "img/030-pillow.8a0e0a92.svg";